<template>
  <div id="app">
    <Header/>
    <router-view/>
    <GetInTouch>
      <template v-slot:title>
        <h2 class="t1">{{$t('get_in_touch.text_1')}} </h2>
        <h2 class="t2">{{$t('get_in_touch.text_2')}} </h2>
        <h2 class="t3">{{$t('get_in_touch.text_3')}}</h2>
        <h2 class="t4">{{$t('get_in_touch.text_4')}}</h2>
      </template>
      <template v-slot:subtitle>
        <p class="t5">{{$t('get_in_touch.text_5')}}</p>
      </template>
      <template v-slot:thankstitle>
        <h2 class="t1">{{$t('get_in_touch.text_12')}}</h2>
        <h2 class="t2">{{$t('get_in_touch.text_13')}} </h2>
        <h2 class="t3">{{$t('get_in_touch.text_14')}}</h2>
      </template>
      <template v-slot:thankssubtitle>
        <p class="t5">{{$t('get_in_touch.text_15')}}</p>
      </template>
    </GetInTouch>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import GetInTouch from '@/components/Blocks/GetInTouch';

export default {
  name: 'App',
  components: {
    Header, Footer, GetInTouch
  },
  created: function () {
    fetch("https://api.npoint.io/fc95a74ce098839a7bce")
      .then(r => r.json())
      .then(json => {
        this.$store.state.jobs=json
      });
    var lang = this.$route.query.lang
    if (lang == 'es' || lang == 'us'){
      this.$i18n.locale = lang
    }
  }
}
</script>

<style>
@import 'assets/kingcomposer.min.css';
@import 'assets/animate.css';
@import 'assets/style.css';
@import 'assets/icons.css';
@import 'assets/theme.css';
@import 'assets/components.css';

body .ssc_img_ef {
    overflow: initial !important;
}

/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */

</style>


// WEBPACK FOOTER //
// src/App.vue